import { RolesV2ResponseDto } from '@tiendanube/common';

export const UsersEndpoints = {
  getUsersList: 'getUsersList',
  getUsersListInf: 'getUsersListInf',
  getUser: 'getUser',
  getShortRoles: 'getShortRoles',
  getFullRoles: 'getFullRoles',
  getRoles: 'getRoles',
  getEmailTypes: 'getEmailTypes',
  createUser: 'createUser',
  updateUser: 'updateUser',
  deleteUser: 'deleteUser',
  getPartnersList: 'getPartnersList',
  getPartnersListInf: 'getPartnersListInf',
  unlinkPartner: 'unlinkPartner',
  getPartnerAdminAccess: 'getPartnerAdminAccess',
  updatePartnerAdminAccess: 'updatePartnerAdminAccess',
} as const;

export const UsersTags = {
  usersList: 'usersList',
  roles: 'roles',
  partnersList: 'partnersList',
  partnerAdminAccess: 'partnerAdminAccess',
  partnersListInf: 'partnersListInf',
} as const;

export type UserRolesType = {
  sections: RolesV2ResponseDto;
  roles: Record<string, string>;
  appRoles: Record<string, string>;
};
